import { RouteName } from "@/router";

export const zendeskUrl = "https://onecareer.zendesk.com";
export const zendeskHelCenterUrl = "https://onecareer.zendesk.com/hc/ja";
export const zendeskWidgetUrl =
  "https://static.zdassets.com/ekr/snippet.js?key=5c68ab2a-8093-4779-8fb8-b775a6be342e";

export interface Faq {
  id: number;
  targetRouteNames: RouteName[];
  title: string;
  url: string;
}

export const faqs: Faq[] = [
  {
    id: 1,
    targetRouteNames: ["Plans", "Plan"],
    title: "自社イベントに入力した情報は他社に公開されますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777663-%E8%87%AA%E7%A4%BE%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AB%E5%85%A5%E5%8A%9B%E3%81%97%E3%81%9F%E6%83%85%E5%A0%B1%E3%81%AF%E4%BB%96%E7%A4%BE%E3%81%AB%E5%85%AC%E9%96%8B%E3%81%95%E3%82%8C%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 2,
    targetRouteNames: ["Plans", "Plan"],
    title: "他社のイベントの元データはなんですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776526-%E7%AB%B6%E5%90%88%E4%BC%81%E6%A5%AD%E3%81%AE%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E5%85%83%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AF%E3%81%AA%E3%82%93%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 3,
    targetRouteNames: ["Plans", "Plan"],
    title: "他社を検索できません。なぜでしょうか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777683-%E7%AB%B6%E5%90%88%E4%BC%81%E6%A5%AD%E3%82%92%E6%A4%9C%E7%B4%A2%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%9B%E3%82%93-%E3%81%AA%E3%81%9C%E3%81%A7%E3%81%97%E3%82%87%E3%81%86%E3%81%8B-"
  },
  {
    id: 4,
    targetRouteNames: ["Plans", "Plan"],
    title: "大学スケジュールの元データはなんですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776606-%E5%A4%A7%E5%AD%A6%E3%82%B9%E3%82%B1%E3%82%B8%E3%83%A5%E3%83%BC%E3%83%AB%E3%81%AE%E5%85%83%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AF%E3%81%AA%E3%82%93%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 5,
    targetRouteNames: ["Plans", "Plan"],
    title: "大学スケジュールは最新情報ですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776586-%E5%A4%A7%E5%AD%A6%E3%82%B9%E3%82%B1%E3%82%B8%E3%83%A5%E3%83%BC%E3%83%AB%E3%81%AF%E6%9C%80%E6%96%B0%E6%83%85%E5%A0%B1%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 6,
    targetRouteNames: ["Plans", "Plan"],
    title: "動向グラフのそれぞれの数字の元データはなんですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777743-%E5%8B%95%E5%90%91%E3%82%B0%E3%83%A9%E3%83%95%E3%81%AE%E3%81%9D%E3%82%8C%E3%81%9E%E3%82%8C%E3%81%AE%E6%95%B0%E5%AD%97%E3%81%AE%E5%85%83%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AF%E3%81%AA%E3%82%93%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 7,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "他社のイベント内容を見る",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777563-%E7%AB%B6%E5%90%88%E4%BC%81%E6%A5%AD%E3%81%AE%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E5%86%85%E5%AE%B9%E3%82%92%E8%A6%8B%E3%82%8B"
  },
  {
    id: 8,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "他社のイベントの元データはなんですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776526-%E7%AB%B6%E5%90%88%E4%BC%81%E6%A5%AD%E3%81%AE%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E5%85%83%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AF%E3%81%AA%E3%82%93%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 9,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "学生は体験談が提供されることに同意していますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776666-%E5%AD%A6%E7%94%9F%E3%81%AF%E4%BD%93%E9%A8%93%E8%AB%87%E3%81%8C%E6%8F%90%E4%BE%9B%E3%81%95%E3%82%8C%E3%82%8B%E3%81%93%E3%81%A8%E3%81%AB%E5%90%8C%E6%84%8F%E3%81%97%E3%81%A6%E3%81%84%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 10,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "最新卒年度の情報は見れますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777703-%E6%9C%80%E6%96%B0%E6%83%85%E5%A0%B1-22%E5%8D%92-%E3%81%AF%E8%A6%8B%E3%82%8C%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 11,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "データを出力したいです。可能でしょうか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001778063-%E3%83%87%E3%83%BC%E3%82%BF%E3%82%92%E5%87%BA%E5%8A%9B%E3%81%97%E3%81%9F%E3%81%84%E3%81%A7%E3%81%99-%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%97%E3%82%87%E3%81%86%E3%81%8B-"
  },
  {
    id: 12,
    targetRouteNames: ["EventExperiences", "EventExperience", "EventDetail"],
    title: "今後開発予定の機能を教えてください。",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776706-%E4%BB%8A%E5%BE%8C%E9%96%8B%E7%99%BA%E4%BA%88%E5%AE%9A%E3%81%AE%E6%A9%9F%E8%83%BD%E3%82%92%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84-"
  },
  {
    id: 13,
    targetRouteNames: ["Notifications"],
    title: "通知はどのような時に行なわれますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777623-%E9%80%9A%E7%9F%A5%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AA%E6%99%82%E3%81%AB%E8%A1%8C%E3%81%AA%E3%82%8F%E3%82%8C%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 14,
    targetRouteNames: ["Notifications"],
    title: "通知をメールでも受信することは可能ですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776506-%E9%80%9A%E7%9F%A5%E3%82%92%E3%83%A1%E3%83%BC%E3%83%AB%E3%81%A7%E3%82%82%E5%8F%97%E4%BF%A1%E3%81%99%E3%82%8B%E3%81%93%E3%81%A8%E3%81%AF%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%99%E3%81%8B--"
  },
  {
    id: 15,
    targetRouteNames: ["Notifications"],
    title: "通知メールを停止するにはどうしたらいいですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900002232863-%E9%80%9A%E7%9F%A5%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%92%E5%81%9C%E6%AD%A2%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%97%E3%81%9F%E3%82%89%E3%81%84%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 16,
    targetRouteNames: ["Clips"],
    title: "データを出力したいです。可能でしょうか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001778063-%E3%83%87%E3%83%BC%E3%82%BF%E3%82%92%E5%87%BA%E5%8A%9B%E3%81%97%E3%81%9F%E3%81%84%E3%81%A7%E3%81%99-%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%97%E3%82%87%E3%81%86%E3%81%8B-"
  },
  {
    id: 17,
    targetRouteNames: ["Clips"],
    title: "通知はどのような時に行なわれますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777623-%E9%80%9A%E7%9F%A5%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AA%E6%99%82%E3%81%AB%E8%A1%8C%E3%81%AA%E3%82%8F%E3%82%8C%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 18,
    targetRouteNames: ["Clips"],
    title: "通知をメールでも受信することは可能ですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776506-%E9%80%9A%E7%9F%A5%E3%82%92%E3%83%A1%E3%83%BC%E3%83%AB%E3%81%A7%E3%82%82%E5%8F%97%E4%BF%A1%E3%81%99%E3%82%8B%E3%81%93%E3%81%A8%E3%81%AF%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%99%E3%81%8B--"
  },
  {
    id: 19,
    targetRouteNames: ["Clips"],
    title: "通知メールを停止するにはどうしたらいいですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900002232863-%E9%80%9A%E7%9F%A5%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%92%E5%81%9C%E6%AD%A2%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%97%E3%81%9F%E3%82%89%E3%81%84%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 20,
    targetRouteNames: ["Clips"],
    title: "今後開発予定の機能を教えてください。",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776706-%E4%BB%8A%E5%BE%8C%E9%96%8B%E7%99%BA%E4%BA%88%E5%AE%9A%E3%81%AE%E6%A9%9F%E8%83%BD%E3%82%92%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84-"
  },
  {
    id: 21,
    targetRouteNames: ["Clips"],
    title: "β版無料期間はいつまででしょうか",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776626-%CE%B2%E7%89%88%E7%84%A1%E6%96%99%E6%9C%9F%E9%96%93%E3%81%AF%E3%81%84%E3%81%A4%E3%81%BE%E3%81%A7%E3%81%A7%E3%81%97%E3%82%87%E3%81%86%E3%81%8B-"
  },
  {
    id: 22,
    targetRouteNames: [],
    title: "通知はどのような時に行なわれますか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001777623-%E9%80%9A%E7%9F%A5%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AA%E6%99%82%E3%81%AB%E8%A1%8C%E3%81%AA%E3%82%8F%E3%82%8C%E3%81%BE%E3%81%99%E3%81%8B-"
  },
  {
    id: 23,
    targetRouteNames: [],
    title: "通知をメールでも受信することは可能ですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776506-%E9%80%9A%E7%9F%A5%E3%82%92%E3%83%A1%E3%83%BC%E3%83%AB%E3%81%A7%E3%82%82%E5%8F%97%E4%BF%A1%E3%81%99%E3%82%8B%E3%81%93%E3%81%A8%E3%81%AF%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%99%E3%81%8B--"
  },
  {
    id: 24,
    targetRouteNames: [],
    title: "通知メールを停止するにはどうしたらいいですか？",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900002232863-%E9%80%9A%E7%9F%A5%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%92%E5%81%9C%E6%AD%A2%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%97%E3%81%9F%E3%82%89%E3%81%84%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B-"
  },
  {
    id: 25,
    targetRouteNames: [],
    title: "今後開発予定の機能を教えてください。",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776706-%E4%BB%8A%E5%BE%8C%E9%96%8B%E7%99%BA%E4%BA%88%E5%AE%9A%E3%81%AE%E6%A9%9F%E8%83%BD%E3%82%92%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84-"
  },
  {
    id: 26,
    targetRouteNames: [],
    title: "β版無料期間はいつまででしょうか",
    url:
      "https://onecareer.zendesk.com/hc/ja/articles/900001776626-%CE%B2%E7%89%88%E7%84%A1%E6%96%99%E6%9C%9F%E9%96%93%E3%81%AF%E3%81%84%E3%81%A4%E3%81%BE%E3%81%A7%E3%81%A7%E3%81%97%E3%82%87%E3%81%86%E3%81%8B-"
  }
];
